export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100 py-12 md:py-14 px-4 md:px-6">
      <div className="max-w-[1100px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-lg font-semibold text-background-50 mb-3">
              <span className="text-primary-400">Kakobuy</span> Finds
            </h3>
            <p className="text-xs text-background-300 leading-relaxed mb-4">
              Your trusted resource for discovering the best Kakobuy spreadsheet collections, product finds, and shopping guides. We help smart shoppers find great products faster.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a href="/" className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-home-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Home</a></li>
              <li><a href="#categories" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Categories</a></li>
              <li><a href="#guide" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Guides</a></li>
              <li><a href="#faq" className="text-xs text-background-300 hover:text-primary-400 transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">Spreadsheet Categories</h4>
            <ul className="space-y-2">
              <li><a href="/kakobuy-spreadsheet/" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Kakobuy Spreadsheet</a></li>
              <li><a href="/cssbuy-spreadsheet/" className="text-xs text-background-300 hover:text-primary-400 transition-colors">CSSBuy Spreadsheet</a></li>
              <li><a href="/superbuy-spreadsheet/" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Superbuy Spreadsheet</a></li>
              <li><a href="/oopbuy-spreadsheet/" className="text-xs text-background-300 hover:text-primary-400 transition-colors">Oopbuy Spreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">Main Platform</h4>
            <p className="text-xs text-background-300 leading-relaxed mb-3">
              Visit our main platform for the complete shopping experience with all product categories and spreadsheets.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              kakobuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-foreground-800 gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} kakobuyfinds.site. All rights reserved.
          </p>
          <p className="text-xs text-background-400">
            Discover the best <strong className="text-background-300">Kakobuy Spreadsheet</strong> collections for smarter shopping.
          </p>
        </div>
      </div>
    </footer>
  );
}